import AddIcon from "@mui/icons-material/Add";
import {Box, Typography} from "@mui/material";

import {PuiDefaultPage, PuiFormikForm, PuiGrid, PuiTable} from "@portnet/ui";
import {Formik} from "formik";
import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate, useParams} from "react-router-dom";
import AppRadioGroup from "../../../../common/components/inputs/AppRadioGroup";
import AppRadioItem from "../../../../common/components/inputs/AppRadioItem";
import AppButton from "../../../../common/components/ui/AppButton";
import AppSection from "../../../../common/components/ui/AppSection";
import {formatPrices} from "../../../../common/utils/helpers";
import * as paiementSouscriptionFormNames from "../others/paiementSouscriptionFormNames";
import {paiementSouscriptionInitialValues} from "../others/paiementSouscriptionInitialValues";
import {paiementSouscriptionTableColumns} from "../others/paiementSouscriptionTableColumns";
import {paiementSouscriptionValidationSchema} from "../others/paiementSouscriptionValidationSchemas";
import {getFactureSouscriptionAction, tracePaymentInAccount} from "../state/paiementSouscriptionActions";
import {formatBusinessDate} from "../../../paiement/formatBusinessDate";
import DialogImportant from "../../../../common/components/general/DialogImportant";


const NavigationActions = ({ formRef, isButtonDisabled, selectedPlatform, methodePaiement, oid }) => {
    const [ifForfaitExist, setIfForfaitExit] = React.useState(false);
    const [openConfirmationWindow, setOpenConfirmationWindow] = React.useState(false);
    const [identifiantTransaction, setIdentifiantTransaction] = React.useState(null);
    const dispatch = useDispatch();
    const {
        content: factureData,
        isLoading: isFactureDataLoading,
        isSuccessed: isFactureDataSuccessed,
    } = useSelector((state) => state.souscription.paiementSouscription.facture);


    const tracePayment = (factureIds, selectedPaymentMethod, oid) => {
        const payload = {
            factureIds,
            moyenPaiement: selectedPaymentMethod,
            oid,// Include the selected payment method
        };
        dispatch(tracePaymentInAccount(payload)); // Invoke tracePaymentInAccount with the new payload
    };

    const {
        existForfaitAvecMemeExercice: existForfait,
        isLoading: existForfaitAvecMemeExerciceLoading,
        isSuccessed: existForfaitAvecMemeExerciceSuccessed,
        error: existForfaitAvecMemeExerciceFailed,
    } = useSelector(
        (state) =>
            state.souscription.nouvelleSouscription.existForfaitAvecMemeExercice
    );

    React.useEffect(() => {
        setIfForfaitExit(existForfait?.hasForfait || false);
        setIdentifiantTransaction(existForfait?.identifiantTransaction || null);
    }, [existForfaitAvecMemeExerciceSuccessed]);

    const handleValiderClick = () => {
        if (!isButtonDisabled && identifiantTransaction) {
            // Show confirmation dialog if there is an identifiantTransaction
            setOpenConfirmationWindow(true);
        } else if (!isButtonDisabled) {
            // Submit the form directly if identifiantTransaction is null
            formRef?.current.submitForm();
        }
        tracePayment(factureData.map((facture) => facture.id), methodePaiement, factureData[0].pagos[0].idTransaccion);
    };

    const handleConfirmOk = () => {
        setOpenConfirmationWindow(false);
        formRef?.current.submitForm();
    };

    return (
        <>
            <PuiGrid container>
                <PuiGrid item>
                    <AppButton
                        onClick={handleValiderClick}
                        disabled={isButtonDisabled}
                    >
                        Valider
                    </AppButton>
                </PuiGrid>
            </PuiGrid>

            {openConfirmationWindow && identifiantTransaction && (
                <DialogImportant
                    open={openConfirmationWindow}
                    close={() => setOpenConfirmationWindow(false)}
                    text="Vous avez déjà un code de paiement réservé non encore réglé, êtes-vous sur de vouloir acheter un nouveau forfait ?"
                    confirmation={true}
                    showTitleIcon={true}
                    confirmOk={handleConfirmOk}
                />
            )}
        </>
    );
};
const LabeledValue = ({
  label,
  value,
  labelWidth,
  valueWidth,
  labelSx = {},
  valueSx = {},
  textAlign = "left",
  sx = {},
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
        fontSize: "0.8rem",
        color: "text.secondary",
        lineHeight: "1.4375em",
        letterSpacing: "0.00938em",
        whiteSpace: "nowrap",
        textAlign,
        ...sx,
      }}
    >
      <Box
        sx={{
          width: labelWidth,
          fontWeight: 600,
          ...labelSx,
        }}
      >
        {label}
      </Box>
      <Box
        sx={{
          width: valueWidth,
          ...valueSx,
        }}
      >
        {value}
      </Box>
    </Box>
  );
};

const PaiementSouscription = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const formRef = React.useRef();
  const [methodePaiement, setMethodePaiement] = React.useState(null);
  const { id: souscriptionId } = useParams();
  const [isButtonDisabled, setIsButtonDisabled] = React.useState(true);
  const [selectedPlatform, setSelectedPlatform] = React.useState(null);



    const {
    content: factureData,
    isLoading: isFactureDataLoading,
    isSuccessed: isFactureDataSuccessed,
  } = useSelector((state) => state.souscription.paiementSouscription.facture);

    useEffect(() => {
        console.log(selectedPlatform);
        if (selectedPlatform === "cmi") {
            setIsButtonDisabled(false);
        }
        else{
            setIsButtonDisabled(true);
        }
    }, [selectedPlatform]);



    const submitHandler = (values) => {
      const form = document.createElement('form');
      form.method = 'post';
      
      form.action = methodePaiement==='fatourati'?factureData[0].emisor.cmiUrlFatourati:
                                                factureData[0].emisor.cmiUrlPEL ;

      factureData[0].configuracionCMI.allRequestParamsEntrySet.forEach(function(value) {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = Object.keys(value)[0];
          input.value = Object.values(value)[0];
          form.appendChild(input);
      });
      const hashInput = document.createElement('input');
      hashInput.type = 'hidden';
      hashInput.name = 'hash';
      hashInput.value = factureData[0].configuracionCMI.hash;
      form.appendChild(hashInput);
      document.body.appendChild(form);
      form.submit();
  };
    <div id="amanpay-button-container"></div>


    const loadAmanaPayScript = (props) => {
        // Ensure the script isn't already loaded
        const existingScript = document.getElementById('amanpay-js');


        if (existingScript) {
            existingScript.remove(); // or you can choose to simply return if the script already exists
        }
        const script = document.createElement('script');
        script.id = "amanpay-js";
        script.src = props.urlAmanPay;
        script.async = true;


        console.log("getJsonProductIds(props.productsIds)" , (props.idProductos));
        // Set the data attributes from props
        script.setAttribute("data-mode", "button");
        script.setAttribute("data-merchant_id", props.idAmanPay);
        script.setAttribute("data-access_key", props.keyAmanPay);
        script.setAttribute("data-amount", props.importeFactura* 100);
        script.setAttribute("data-order_id", props.idPago);
        script.setAttribute("data-hmac", props.hmac);
        script.setAttribute("data-currency", props.moneda);
        script.setAttribute("data-products_ids", props.idProductos);
        script.setAttribute("data-business_date", formatBusinessDate(props.fecha));
        script.setAttribute("data-expiration_date", props.dateExpiration);
        script.setAttribute("data-redirect_url", "/portnet/ServletRecibirConfirmacionAmanPay");

        const container = document.getElementById('amanpay-button-container');
        container.appendChild(script);
    };

    const handlePlatformChange = (value) => {
        setSelectedPlatform(value);
        if (value === 'amanPay') {
            console.log(factureData[0].configuracionAmanPay);
            loadAmanaPayScript(factureData[0].configuracionAmanPay);
        }
        else{
            const amanaPayButtonContainer = document.getElementById('amanpay-button-container');
            amanaPayButtonContainer.innerHTML = '';

        }
    };


    React.useEffect(() => {
    dispatch(getFactureSouscriptionAction(souscriptionId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PuiDefaultPage
      title="Régler des factures"
      titleIcon={<AddIcon />}
      trace={["Consultation des souscriptions", "Régler des factures"]}
      navActions={<NavigationActions
          formRef={formRef}
          isButtonDisabled={isButtonDisabled}
          selectedPlatform={selectedPlatform}
          methodePaiement={methodePaiement}
          oid={factureData[0]?.oid || null}
      />}
      loading={isFactureDataLoading}
      show={isFactureDataSuccessed}
      topNav
      bottomNav
      retour
      onRetour={() => navigate(-1)}
    >
      {isFactureDataSuccessed && (
        <AppSection>
          <PuiGrid container spacing={3}>
            <PuiGrid item xs={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: "1em",
                  fontWeight: 600,
                  textAlign: "center",
                  color: "success.main",
                }}
              >
                Veuillez confirmer le règlement des factures suivantes
              </Typography>
            </PuiGrid>
            <PuiGrid item xs={12}>
              <LabeledValue
                label="Nom du client:"
                value={factureData[0].cliente.operadorImpExp?.description}
                labelWidth="110px"
                valueWidth="80px"
              />
              <LabeledValue
                label="Code douanaire:"
                value={factureData[0].cliente.codigoAduana}
                labelWidth="110px"
                valueWidth="80px"
              />
              <LabeledValue
                label="Emetteur:"
                value={factureData[0].emisor.nombre}
                labelWidth="110px"
                valueWidth="80px"
              />
            </PuiGrid>
            <PuiGrid item xs={12}>
              <PuiTable
                columns={paiementSouscriptionTableColumns}
                rows={factureData}
                loading={isFactureDataLoading}
                getRowId={(row) => row.id}
              />
            </PuiGrid>
            <PuiGrid
              item
              xs={12}
              sx={{ display: "flex", flexDirection: "column" }}
            >
              <LabeledValue
                label="Total TVA:"
                value={`${formatPrices(
                  parseInt(factureData[0].importeTTC) -
                    parseInt(factureData[0].importeHT)
                )} MAD`}
                textAlign="right"
                labelWidth="150px"
                valueWidth="80px"
                sx={{ justifyContent: "end" }}
              />
              <LabeledValue
                label="Montant HT:"
                value={`${formatPrices(factureData[0].importeHT)} MAD`}
                textAlign="right"
                labelWidth="150px"
                valueWidth="80px"
                sx={{ justifyContent: "end" }}
              />
              <LabeledValue
                label="Montant TTC:"
                value={`${formatPrices(factureData[0].importeTTC)} MAD`}
                textAlign="right"
                labelWidth="150px"
                valueWidth="80px"
                sx={{ justifyContent: "end" }}
              />
              <LabeledValue
                label="Montant global TTC:"
                value={`${formatPrices(factureData[0].importeTTC)} MAD`}
                textAlign="right"
                labelWidth="150px"
                valueWidth="80px"
                valueSx={{ color: "error.main" }}
                sx={{ justifyContent: "end" }}
              />
            </PuiGrid>

            <PuiGrid item xs={12}>
              <Formik
                initialValues={paiementSouscriptionInitialValues}
                validationSchema={paiementSouscriptionValidationSchema}
                onSubmit={submitHandler}
                innerRef={formRef}
              >
                {({ values }) => (
                  <PuiFormikForm>
                    <PuiGrid container>
                      <PuiGrid item xs={12} sm={8} md={6}>
                        <AppRadioGroup
                          name={
                            paiementSouscriptionFormNames.PAIEMENT_SOUSCRIPTION_PLATEFORME_PAIEMENT_FORM_NAME
                          }
                          label="Plateformes de paiement"
                          onChange={(event) => handlePlatformChange(event.target.value)}
                        >
                          <AppRadioItem label="CMI" value="cmi" />
                          <AppRadioItem label="AmanaPay" value="amanPay" />
                        </AppRadioGroup>
                      </PuiGrid>
                      {values.plateformePaiement === "cmi" && (
                        <PuiGrid item>
                          <AppRadioGroup
                            name={
                              paiementSouscriptionFormNames.PAIEMENT_SOUSCRIPTION_MODE_PAIEMENT_FORM_NAME
                            }
                            label="Mode de paiement">
                            <AppRadioItem
                              label="Carte bancaire"
                              value="carte"
                              onChange={(e) => setMethodePaiement("carte")}
                            />
                            <AppRadioItem 
                            label="Fatourati" 
                            value="fatourati"
                            onChange={(e) => setMethodePaiement("fatourati")}
                             />

                          </AppRadioGroup>
                        </PuiGrid>
                      )}
                        <div id="amanpay-button-container" />
                    </PuiGrid>
                  </PuiFormikForm>
                )}
              </Formik>
            </PuiGrid>
          </PuiGrid>
        </AppSection>
      )}
    </PuiDefaultPage>
  );
};

export default PaiementSouscription;
